import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { NOTIFICATION_NO_CHANGES } from '../../../../constants/notification'
import { useInlineNotifications, usePrevious } from '../../../../hooks'
import { getNotificationNoChanged } from '../../../../utils/notification'
import { FormInlineNotifications } from '../../../Form'
import { ProfileContactsWidgetButtonSelect } from '../ProfileContactsWidgetButtonSelect'
import { ProfileContactsWidgetCreateFormField } from '../ProfileContactsWidgetCreateFormField'
import { ProfileContactsWidgetFormButtons } from '../ProfileContactsWidgetFormButtons'

import { DROPDOWN_OFFSET_CONFIG } from './ProfileContactsWidgetCreateFormContent.constants'
import {
  getDeleteHandlers,
  getIsAnyFieldEmpty,
  getIsLastContact,
} from './ProfileContactsWidgetCreateFormContent.utils'

import * as styles from './ProfileContactsWidgetCreateFormContent.module.css'

function ProfileContactsWidgetCreateFormContent({
  addTypes,
  existingTypes,
  initialValues,
  name,
  newContacts,
  onClick,
  onRemoveContact,
  onSelectItem,
}) {
  const { t } = useTranslation()

  const { isSubmitting, setFieldValue, submitCount, values } =
    useFormikContext()

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  useEffect(() => {
    newContacts.forEach(contact => {
      if (values[contact.id] === undefined) {
        setFieldValue(String(contact.id), initialValues[contact.id])
      }
    })
  }, [newContacts])

  const deleteHandlers = getDeleteHandlers({
    newContacts,
    onClick,
    onRemoveContact,
  })

  const isAnyFieldEmpty = getIsAnyFieldEmpty({ name, newContacts, values })

  const previousSubmitCount = usePrevious(submitCount)

  useEffect(() => {
    if (!isAnyFieldEmpty) {
      handleRemoveNotification(NOTIFICATION_NO_CHANGES)
    } else if (submitCount > previousSubmitCount) {
      handleAddNotification(getNotificationNoChanged(t))
    }
  }, [isAnyFieldEmpty, submitCount])

  return (
    <div className={styles.wrapper}>
      <FormInlineNotifications notifications={notifications} />
      {newContacts.map((contact, index) =>
        values[contact.id] ? (
          <ProfileContactsWidgetCreateFormField
            autoFocus={getIsLastContact({ index, newContacts })}
            contact={contact}
            key={contact.id}
            name={name}
            onDelete={deleteHandlers[contact.id]}
          />
        ) : null
      )}
      <ProfileContactsWidgetButtonSelect
        addTypes={addTypes}
        className={styles.buttonSelect}
        disabled={isAnyFieldEmpty || isSubmitting}
        existingTypes={existingTypes}
        offsetConfig={DROPDOWN_OFFSET_CONFIG}
        onSelectItem={onSelectItem}
      />
      <ProfileContactsWidgetFormButtons onCancel={onClick} />
    </div>
  )
}

export default ProfileContactsWidgetCreateFormContent
